var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loading" }, [
    _c(
      "div",
      { staticClass: "wrapperL" },
      [
        _c(
          "van-loading",
          {
            staticClass: "loadingS",
            attrs: {
              size: "36px",
              type: "spinner",
              color: "#fff",
              "text-color": "#fff",
              vertical: ""
            }
          },
          [_vm._v(_vm._s(_vm.title))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }